import constants from '../constants.js';

const FeatureId = {
  displayName: 'Identifier',
  dataAt: 'Id',
  disabled: true,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const FeatureResourceName = {
  displayName: 'Feature Name',
  dataAt: 'Name',
  disabled: true,
  displayAs: constants.DISPLAY_AS.TEXT_INPUT
};

const FeatureName = {
  displayName: 'Feature Name',
  dataAt: 'Name',
  displayAs: constants.DISPLAY_AS.FEATURE_SELECT,
  endpoint: 'Features',
  required: true
};

const FeatureDebtors = {
  displayName: 'Debtors',
  dataAt: 'Debtors',
  displayAs: constants.DISPLAY_AS.DEBTORS_MULTI_SELECT,
  endpoint: 'Debtors'
};

const FeatureStatus = {
  displayName: 'Is Enabled',
  dataAt: 'Enabled',
  displayAs: constants.DISPLAY_AS.BOOLEAN
};

const FeaturesResource = {
  displayName: 'Feature Flag',
  displayAs: constants.DISPLAY_AS.RESOURCE,
  dataAt: '$featureID',
  children: [FeatureId, FeatureResourceName, FeatureDebtors, FeatureStatus],
  endpoint: 'FeatureFlags',
  routeParamId: 'featureID'
};

const FeaturesAddResource = {
  displayAs: constants.DISPLAY_AS.ADD_GRID_RESOURCE,
  displayName: 'Feature Flag',
  data: {
    Name: null,
    Debtors: [],
    Enabled: true
  },
  dataAt: '',
  children: [FeatureName, FeatureDebtors, FeatureStatus],
  endpoint: 'FeatureFlags'
};

const FeaturesList = {
  rootNode: true,
  displayName: 'Feature Flags',
  endpoint: 'FeatureFlags',
  displayAs: constants.DISPLAY_AS.GRID,
  canAddNew: true,
  gridItem: FeaturesResource,
  gridAdd: FeaturesAddResource,
  gridCols: [
    {name: 'Name', key: 'Name'},
    {name: 'Enabled', key: 'Enabled'}
  ]
};

export default {
  FeaturesList,
  FeaturesResource,
  FeaturesAddResource,
  FeatureResourceName,
  FeatureName
}



// WEBPACK FOOTER //
// ./src/config/fields/features.js